import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { testimonials } from "../constants";
import styled, { css } from "react-emotion";

const Slide = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 60vh;
  line-height: 1.5;
  font-size: 1.5em;
  color: #89d2d3;
  background-color: #f6fbfb;
  flex-flow: row wrap;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol {
    border: 0;
    margin: 10px auto;
    padding: 0;
    display: inline-block;
    width: 100%;
  }
`;

const imageCropper = css`
  width: 200px;
  height: 200px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 20px;
`;

const logoStyle = css`
  margin: 0 auto;
  height: 100%;
  width: auto;
`;

const H4 = styled("h4")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  color: #000000;
  display: block;
  font-size: 0.5em;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
  @media only screen and (min-width: 768px) {
    font-size: 1.2em;
  }
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  @media only screen and (min-width: 768px) {
    font-size: 18px;
  }
`;

export default () => (
  <div style={{ textAlign: "center" }}>
    <Carousel
      autoPlay
      // width="700px"
      infiniteLoop={true}
      interval={3000}
      className="presentation-mode"
      showThumbs={false}
      showStatus={false}
      swipeable={true}
      // style={{ height: "600px" }}
      renderIndicator={(onClickHandler, isSelected, index, label) => {
        if (isSelected) {
          return (
            <li
              style={{
                width: 8,
                height: 8,
                display: "inline-block",
                margin: "0 8px",
                background: "#89d2d3",
                WebkitTransition: "opacity 0.25s ease-in",
                MozTransition: "opacity 0.25s ease-in",
                msTransition: "opacity 0.25s ease-in",
                OTransition: "opacity 0.25s ease-in",
                transition: "opacity 0.25s ease-in",
                filter: "alpha((opacity = 100))",
                boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.9)",
                borderRadius: "50%",
                cursor: "pointer",
                opacity: "1",
              }}
              aria-label={`Selected: ${label} ${index + 1}`}
              title={`Selected: ${label} ${index + 1}`}
            />
          );
        }
        return (
          <li
            style={{
              width: 8,
              height: 8,
              display: "inline-block",
              margin: "0 8px",
              background: "#fff",
              WebkitTransition: "opacity 0.25s ease-in",
              MozTransition: "opacity 0.25s ease-in",
              msTransition: "opacity 0.25s ease-in",
              OTransition: "opacity 0.25s ease-in",
              transition: "opacity 0.25s ease-in",
              filter: "alpha((opacity = 30))",
              boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.9)",
              borderRadius: "50%",
              cursor: "pointer",
              opacity: "0.3",
            }}
            onClick={onClickHandler}
            onKeyDown={onClickHandler}
            value={index}
            key={index}
            role="button"
            tabIndex={0}
          />
        );
      }}
    >
      {testimonials.map((t) => {
        return (
          <Slide key={t.name}>
            <div className={imageCropper}>
              <img className={logoStyle} src={t.logo} alt={t.name}></img>
            </div>
            <div style={{ width: "77%" }}>
              <P>"{t.description}"</P>
              <P> - {t.name}</P>
            </div>
          </Slide>
        );
      })}
    </Carousel>
  </div>
);
